import React, { useState, useEffect, ChangeEvent, useRef } from "react";
import OutletFormProgressCard from "./OutletFormProgressCard";
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  MenuItem,
  InputLabel,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Stack,
  TextField,
  SelectChangeEvent,
  Tooltip,
  Autocomplete,
  mobileStepperClasses,
  CircularProgress,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import {
  autocompleteLableMarginFix,
} from "../../components/createSecondaryOrder/util";
import { GenericModal, getGenericModalProps } from "./ViewOrderUtils";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import { ReactComponent as DisclaimerIcon } from "../../assets/image/svg/disclaimer.svg";
import {
  createOutlet,
  getOutletDetailsForForm,
  getSalesRepDataForOutlet,
  keysToAddConfig,
  getOutletChannelFields,
  Feature,
  getSendOtpRequestBody,
  sendOtpOutletCreation,
  otpState,
  getRoutes,
  updateOutlet,
  customSxOutletForm
} from "./OutletFormUtils";
import { Loader } from "../../components/loader/Loader";
import { getConfigData } from "../../services/configurationService";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import dayjs from "dayjs";
import ValidateOtpPopupCounterSales from "./ValidateOtpPopupCounterSales";
import { getOutletCreditInfo } from "../viewOutletDetails/ViewOutletDetailsUtils";
const OutletForm: React.FC<{
  onClose?: () => void;
  onSaveOutletForm?: (data: any, newRoute: string) => void;
}> = ({ onClose, onSaveOutletForm }) => {
  const initialGenericModalProps: GenericModal = {
    open: false,
    type: "positive",
    message: "",
  };
  const isPriceGroupRequired = useRef<boolean>(true);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const MAX_TIME = 60;
  const [outletTypeValues, setOutletTypeValues] = useState<string[]>([]);
  const [subChannelValues, setSubChannelValues] = useState<string[]>([]);
  const [channelValues, setChannelValues] = useState<string[]>([]);
  const [outletClassValues, setOutletClassValues] = useState<string[]>([]);
  const [priceListValues, setPriceListValues] = useState<string[]>([]);
  const [paymentModeValues, setPaymentModeValues] = useState<string[]>([]);
  const [categoryValues, setCategoryValues] = useState<string[]>([]);
  const [allRouteValues, setAllRouteValues] = useState<any[]>([]);
  const [routeValues, setRouteValues] = useState<string[]>([]);
  const [cityValues, setCityValues] = useState<string[]>([]);
  const [stateCityMap, setStateCityMap] = useState<Record<string, string[]>>({});
  const [shipToCityValues, setShipToCityValues] = useState<string[]>([]);
  const [buttonLoadingIcon, setButtonLoadingIcon] = useState<boolean>(false);
  const buttonLoading = useRef<boolean>(false);
  const [verifyLoader, setVerifyLoader] = useState<boolean>(false);
  
  const [salesRepValues, setSalesRepValues] = useState<
    { id: string; name: string }[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const supplierId = JSON.parse(localStorage.authContext)?.user?.loginId;
  const supplierName = JSON.parse(localStorage.authContext)?.user?.name;
  const [selectedSalesrep, setSelectedSalesrep] = useState<string>("");
  const [otpStatus, setOtpStatus] = useState<otpState>(otpState.INVALID);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [duplicateOuletsData, setDuplicateOutletsData] = useState<any>();
  const [showOtpPopup, setShowOtpPopup] = useState<boolean>(false);
  const [resendOtpState, setResendOtpState] = useState(false);
  const [canEditForm, setCanEditForm] = useState<boolean>(true);
  const outletIsCredit = useRef<boolean>(false);

  const defaultCreditLimit = useRef<string>("0")
  const defaultCreditDays = useRef<string>("0")

  const outletLocationTransformerName = useRef<string>("outlet_location_transformer");

  const handleOtpPopupClose = () => {
    setShowOtpPopup(false);
  };

  const designation = JSON.parse(localStorage.authContext)?.user?.designation;
  useEffect(() => {
    const fetchDropDownData = async () => {
      try {
        setLoading(true); // Start loading

        const data = await getOutletChannelFields();

        const features: Feature[] = data.data.features;

        const channelValuesData: string[] = Array.from(
          new Set(
            features
              .filter(
                (feature) =>
                  feature.key1 === "ChannelCode" &&
                  feature.key2 != null &&
                  feature.key2.trim() !== ""
              )
              .map((feature) => feature.key2.trim())
          )
        );

        const subChannelValuesData: string[] = Array.from(
          new Set(
            features
              .filter(
                (feature) =>
                  feature.key1 === "SubChannelCode" &&
                  feature.key2 != null &&
                  feature.key2.trim() !== ""
              )
              .map((feature) => feature.key2.trim())
          )
        );

        const categoryData: string[] = Array.from(
          new Set(
            features
              .filter(
                (feature) =>
                  feature.key1 === "GroupCode" &&
                  feature.key2 != null &&
                  feature.key2.trim() !== ""
              )
              .map((feature) => feature.key2.trim())
          )
        );

        const outletClassData: string[] = Array.from(
          new Set(
            features
              .filter(
                (feature) =>
                  feature.key1 === "ClassCode" &&
                  feature.key2 != null &&
                  feature.key2.trim() !== ""
              )
              .map((feature) => feature.key2.trim())
          )
        );

        const [
          outletTypeValuesData,
          priceListIdData,
          paymentModeData,
          routeData,
          salesRepData,
        ] = await Promise.all([
          getOutletDetailsForForm("outletType"),
          getOutletDetailsForForm("priceListId"),
          getOutletDetailsForForm("paymentMode"),
          getRoutes(),
          // getOutletDetailsForForm("beat"),
          getSalesRepDataForOutlet(),
        ]);

        setOutletTypeValues(outletTypeValuesData ?? []);
        setSubChannelValues(subChannelValuesData ?? []);
        setChannelValues(channelValuesData ?? []);
        setOutletClassValues(outletClassData ?? []);
        setPriceListValues(priceListIdData ?? []);
        setPaymentModeValues(paymentModeData ?? []);
        setCategoryValues(categoryData ?? []);
        setAllRouteValues(routeData ?? [])
        setSalesRepValues(salesRepData ?? []);
      } catch (error) {
        console.error("Failed to fetch dropdown data:", error);
        // Optionally show an error message or fallback
      } finally {
        setLoading(false); // Stop loading
      }
    };
    const fetchRequiredConfigs = async () => {
      const res = await getConfigData(
        "dms_configuration",
        "isPriceGroupRequired"
      );
      const res1 = await getConfigData(
        "salesman_app_options_configuration",
        "stateCityMap"
      )
      const res2 = await getConfigData(
        "dms_configuration",
        "defaultCreditLimit"
      )
      const res3 = await getConfigData(
        "dms_configuration",
        "defaultCreditDays"
      )
      const outletLocationTransformerConfig = await getConfigData(
        "dms_configuration",
        "outletLocationTransformerName"
      );
      setStateCityMap(res1[0]?.configValue ?? {})
      defaultCreditLimit.current = (res2[0]?.configValue ?? "0")
      defaultCreditDays.current = (res3[0]?.configValue ?? "0")
      isPriceGroupRequired.current = res[0]?.configValue ?? true; //need to be truue
      outletLocationTransformerName.current = outletLocationTransformerConfig[0]?.configValue ?? "outlet_location_transformer";
    };

    fetchDropDownData();
    fetchRequiredConfigs();
  }, []);

  useEffect(() => {
    if (!duplicateOuletsData) return;

    const populateFormData = async () => {
      let bank = "",
        ifsc = "",
        outletPan = "",
        outletGstin = "",
        shiptoGSTIN = "";
      let creditLimit = "", creditDays = "", creditAvailable="";

      const {
        id,
        activeStatus,
        outletName,
        outletCode,
        channel: outletChannel,
        outletClass,
        address: outletAddress,
        location = {},
        contactno: outletContact,
        email: outletEmail,
        extendedAttributes = {},
        immediateParent,
        latitude: outletLatitude,
        longitude: outletLongitude,
        creationTime: outletCreateDate,
        account: outletAccountNo,
        outletType,
        subChannel: outletSubChannel,
        priceListId: outletPriceGroup,
        outletCategory,
        beat: outletRoute,
        blobKey: imageUrl,
      } = duplicateOuletsData;

      const {
        city: outletCity,
        pincode: outletPincode,
        state: outletState,
      } = location;

      const {
        preferredPaymentMode: paymentMode,
        discountPercentage,
        cashDiscount,
        loyaltybalance: loyaltyBalance,
        walletbalance: walletBalance,
        shipTo = {},
        keyAccount,
        salesrep: salesRepCode,
        salesRepName,
        supplierName,
        tcsEligibility,
      } = extendedAttributes;

      const [res1] = await Promise.all([getOutletCreditInfo(outletCode ?? "")]);

      if (res1?.data?.features?.length > 0) {
        const data2 = res1.data.features[0];
        ({ creditLimit = "", totalDueDays: creditDays = "", creditAvailable = "" } = data2);
      }

      const distributorCode =
        extendedAttributes["parent-1-0-id"] ??
        extendedAttributes["parent-0-1-id"] ??
        extendedAttributes["distributor"] ??
        "";

      const {
        city: shipToCity,
        state: shipToState,
        address: shipToAddress,
        pincode: shipToPincode,
        contactNo: shipToContact,
        contactName: shipToContactPersonName,
        description: shipToDescription,
      } = shipTo;

      setFormData((prev) => ({
        outletName: outletName ?? "",
        city: outletCity ?? "",
        mobileNo: outletContact ?? "",
        pincode: outletPincode ?? "",
        address: outletAddress ?? "",
        salesRepId: prev.salesRepId ?? "",
        channel: outletChannel ?? "",
        email: outletEmail ?? "",
        managerName: JSON.parse(localStorage.authContext)?.user?.loginId ?? "",

        latitude: outletLatitude ?? "",
        keyAccount: keyAccount ?? "",
        longitude: outletLongitude ?? "",
        outletClass: outletClass ?? "",
        state: outletState ?? "",

        paymentMode: paymentMode ?? "",
        outletDiscount: discountPercentage ?? "",
        outletAccountNumber: "******",
        outletBank: "*****",
        outletIfscCode: "***********",
        creditLimit: creditLimit ?? "",
        creditDays: creditDays ?? "",
        creditAvailable: creditAvailable ?? "",
        outletCashDiscount: cashDiscount ?? "",
        tcsEligibility: tcsEligibility ?? "",

        outletGstin: "***************",
        outletPan: "**********",
        shipToGstin: "***************",
        shipToContactPersonName: shipToContactPersonName ?? "",
        shipToDescription: shipToDescription ?? "",
        shipToAddress: shipToAddress ?? "",
        shipToCity: shipToCity ?? "",
        shipToContactNo: shipToContact ?? "",
        shipToPincode: shipToPincode ?? "",
        shipToState: shipToState ?? "",

        outletStatus: activeStatus ?? "",
        outletType: outletType ?? "",
        subChannel: outletSubChannel ?? "",
        loyaltyBalance: loyaltyBalance ?? "",
        walletBalance: walletBalance ?? "",
        outletPriceGroup: outletPriceGroup ?? "",
        outletCategory: outletCategory ?? "",
        outletRoute: prev.outletRoute ?? "",
        supplierName: prev.supplierName ?? "",
        salesRepName: prev.salesRepName ?? "",
      }));

      setCanEditForm(false);
    };

    populateFormData();
  }, [duplicateOuletsData]);

  useEffect(() => {
    const otpValid = otpStatus === otpState.VALID;
    const status = otpValid ? "positive" : "error";
    if (errorMessage) {
      setGenericModalProps(
        getGenericModalProps(status, errorMessage, "Ok", ``, () => {
          setGenericModalProps(initialGenericModalProps);
          setErrorMessage("");
        })
      );
    }
  }, [errorMessage]);

  const getRoutesBySalesrep = (salesrep: string) => {
    const filteredRouteCodes = allRouteValues
      .filter((item: any) => item.salesmanCode === salesrep)
      .map((item: any) => item.routeCode);

    const uniqueRouteCodes: string[] = Array.from(new Set(filteredRouteCodes));
    return uniqueRouteCodes
  }

  const [formData, setFormData] = useState<FormDataType>({
    // Page 1 fields
    outletName: "",
    city: "",
    mobileNo: "",
    pincode: "",
    address: "",
    salesRepId: "",
    channel: "",
    email: "",
    managerName: JSON.parse(localStorage.authContext)?.user?.loginId,
    latitude: "",
    keyAccount: "false",
    longitude: "",
    outletClass: "",
    state: "",
    // Page 2 fields
    paymentMode: "",
    outletDiscount: "",
    outletAccountNumber: "",
    outletBank: "",
    outletIfscCode: "",
    creditLimit: "",
    creditDays: "",
    creditAvailable: "",
    outletCashDiscount: "",
    tcsEligibility: "Y",

    // page 3 fields
    outletGstin: "",
    outletPan: "",
    shipToGstin: "",
    shipToContactPersonName: "",
    shipToDescription: "",
    shipToAddress: "",
    shipToCity: "",
    shipToContactNo: "",
    shipToPincode: "",
    shipToState: "",

    //page 4
    outletStatus: "inactive",
    outletType: "",
    subChannel: "",
    loyaltyBalance: "",
    walletBalance: "",
    outletPriceGroup: "",
    outletCategory: "",
    outletRoute: "",
    supplierName: supplierName,
    salesRepName: "",
  });

  const [currentPage, setCurrentPage] = useState(1);

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
      | SelectChangeEvent<string>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSelectOptionChange = <T extends keyof FormData>(
    event: SelectChangeEvent<string>,
    optionsArray: readonly string[]
  ) => {
    const { name, value: selectedValue } = event.target;

    // Only update if the selected value is not the 0th index of the provided options array
    if (selectedValue !== optionsArray[0]) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedValue, // Dynamically update the correct field
      }));
    } else {
      // For all other indices, set the field to the selected value
      setFormData((prevData) => ({
        ...prevData,
        [name]: "",
      }));
    }
  };

  const handleAutocompleteSelect = async (
    name: keyof FormDataType,
    selectedValue: string | null,
    optionsArray: readonly string[]
  ) => {
    if (name === "outletRoute"){
      setOtpStatus(otpState.INVALID);
    }
    if (name === "paymentMode"){
      outletIsCredit.current = selectedValue?.toLocaleLowerCase() === "credit";
      setFormData((prevData) => ({
        ...prevData,
        "creditLimit": "",
        "creditAvailable": "",
        "creditDays": "",

      }))
    }
    if (name === "salesRepId") {
      const routeData = getRoutesBySalesrep(selectedValue ?? "");
      setRouteValues(routeData ?? []);
      setFormData((prevData) => ({
        ...prevData,
        "outletRoute": "",
      }))
      setOtpStatus(otpState.INVALID);
    }
    if (name === "state"){
      setCityValues(stateCityMap[selectedValue ?? ""] ?? [])
      setFormData((prevData) => ({
        ...prevData,
        "city": "",
      }))
    }
    if (name === "shipToState"){
      setShipToCityValues(stateCityMap[selectedValue ?? ""] ?? [])
      setFormData((prevData) => ({
        ...prevData,
        "shipToCity": "",
      }))
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: selectedValue ?? "", // if null, set empty string
    }));
  };

  const stages: Record<string, number> = {
    OUTLET_DETAILS: 1,
    FINANCIAL_DETAILS: 2,
    SHIPPING_AND_BILLING_DETAILS: 3,
    ADDITIONAL_DETAILS: 4,
  };

  const counterSalesOutletFormTrackingStages = {
    name: "counterSalesOutletFormTrackingStages",
    type: "list",
    value: [
      {
        id: "ALL",
        color: "#0070C0",
        dmsLabel: "All Orders",
      },
      {
        id: "OUTLET_DETAILS",
        color: "#0070C0",
        dmsColor: "#F0F3FF",
        dmsLabel: "Outlet Details",
        dmsLabelColor: "#4F69D1",
      },
      {
        id: "FINANCIAL_DETAILS",
        dmsLabel: "Financial Details",
        color: "#002060",
        dmsColor: "#F3FCF3",
        dmsLabelColor: "#23C65B",
      },
      {
        id: "SHIPPING_AND_BILLING_DETAILS",
        color: "#00B050",
        dmsColor: "#EDF7FF",
        dmsLabel: "Shipping & Billing Details",
        dmsLabelColor: "#118EEB",
      },
      {
        id: "ADDITIONAL_DETAILS",
        dmsLabel: "Additional Details",
        color: "#B27A10",
        dmsColor: "#FDFCFA",
        dmsLabelColor: "#D9A84D",
      },
    ],
    docUrl: "",
    description: "counter sales outlet form tracking stages",
    defaultValue: [],
    possibleVals: [],
  };

  const invalidFieldColor = (field: keyof FormDataType) => {
    const bgColor =
      !isFieldValid(field) && formData[field]
        ? "#FFFAF7"
        : styles.formInput.backgroundColor;
    const borderColor =
      !isFieldValid(field) && formData[field]
        ? "red"
        : styles.formInput.borderColor;
    return {
      backgroundColor: bgColor,
      borderColor: borderColor,
    };
  };

  const diabledFieldColor = () => {
    if (!canEditForm){
      const color = "rgba(0, 0, 0, 0.38)"
      return {
        color: color
      };
    }
  };

  // Handle close button click with confirmation
  const handleCloseClick = () => {
    if (isFormEmpty()) {
      // If nothing has been filled, close the form directly
      if (onClose) onClose();
    } else {
      const closeConfirmModalProps = getGenericModalProps(
        `positive`,
        `Are you sure you want to close this form? Any unsaved changes will be lost.`,
        `Confirm`,
        `Cancel`,
        () => {
          setGenericModalProps(initialGenericModalProps);
          // Call the onClose function passed as prop
          if (onClose) onClose();
        },
        () => setGenericModalProps(initialGenericModalProps)
      );
      setGenericModalProps(closeConfirmModalProps);
    }
  };

  // Add this function to check if any field has a value
  const DEFAULT_VALUES = {
    keyAccount: "false",
    managerName: JSON.parse(localStorage.authContext)?.user?.loginId,
    tcsEligibility: "Y",
    outletStatus: "inactive",
    supplierName: supplierName,
  } as const;

  const isFormEmpty = () => {
    return Object.entries(formData).every(([key, value]) => {
      if (key in DEFAULT_VALUES) {
        return value === DEFAULT_VALUES[key as keyof typeof DEFAULT_VALUES];
      }
      return value === "";
    });
  };

  const handleReset = () => {
    const updatedGenericModalProps = getGenericModalProps(
      `positive`,
      `Are you sure you want to reset? Any unsaved changes will be lost.`,
      `Confirm`,
      `Cancel`,
      async () => {
        await resetForm();
        setGenericModalProps(initialGenericModalProps);
      },
      () => setGenericModalProps(initialGenericModalProps)
    );
    setGenericModalProps(updatedGenericModalProps);
  };

  const resetForm = async () => {
    setFormData({
      //page 1
      outletName: "",
      city: "",
      pincode: "",
      mobileNo: "",
      keyAccount: "false",
      address: "",
      salesRepId: "",
      channel: "",
      managerName: JSON.parse(localStorage.authContext)?.user?.loginId,
      latitude: "",
      outletClass: "",
      longitude: "",
      email: "",
      state: "",
      // page 2
      paymentMode: "",
      creditDays: "",
      outletDiscount: "",
      creditLimit: "",
      creditAvailable: "",
      outletAccountNumber: "",
      outletIfscCode: "",
      outletBank: "",
      outletCashDiscount: "",
      tcsEligibility: "Y",

      // page 3
      outletGstin: "",
      outletPan: "",
      shipToGstin: "",
      shipToContactPersonName: "",
      shipToDescription: "",
      shipToAddress: "",
      shipToCity: "",
      shipToContactNo: "",
      shipToPincode: "",
      shipToState: "",

      //page 4
      outletStatus: "inactive",
      outletType: "",
      subChannel: "",
      loyaltyBalance: "",
      walletBalance: "",
      outletPriceGroup: "",
      outletCategory: "",
      outletRoute: "",
      supplierName: supplierName,
      salesRepName: "",
    });
    setCanEditForm(true);
    setOtpStatus(otpState.INVALID);
    setCurrentPage(1);
  };

  const PINCODE_REGEX = /^\d{6}$/;
  const MOBILE_NO_REGEX = /^\d{10}$/;
  const LONGITUDE_REGEX = /^(-?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?))$/;
  const LATITUDE_REGEX = /^(-?(90(\.0+)?|([1-8]?\d)(\.\d+)?))$/;
  const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const isPage1Complete = () => {
    if (!canEditForm){
      return true
    }
    const page1Fields = {
      outletName: formData.outletName,
      city: formData.city,
      pincode: formData.pincode,
      mobileNo: formData.mobileNo,
      // keyAccount: formData.keyAccount,
      address: formData.address,
      salesRepId: formData.salesRepId,
      channel: formData.channel,
      // managerName: formData.managerName,
      latitude: formData.latitude,
      // outletClass: formData.outletClass,
      longitude: formData.longitude,
      // email: formData.email,
      outletRoute: formData.outletRoute,
      
    };
    // Check if all fields are non-empty
    const allFieldsFilled = Object.values(page1Fields).every(
      (value) => value !== ""
    );

    // Ensure pincode is exactly 6 digits & mobileNo is exactly 10 digits
    const isPincodeValid = PINCODE_REGEX.test(formData.pincode);
    const isMobileNoValid = MOBILE_NO_REGEX.test(formData.mobileNo);
    const isValidLongitude = LONGITUDE_REGEX.test(formData.longitude);
    const isValidLatitude = LATITUDE_REGEX.test(formData.latitude);
    const isOutletNameValid = formData.outletName.length >= 2;
    const isOutletAddressValid = formData.address.length >= 5;
    const isOutletCityValid = formData.city.length >= 3;
    const email = formData.email;
    const otpValid = otpStatus === otpState.VALID;

    return (
      (!email || (email.length >= 11 && EMAIL_REGEX.test(email))) &&
      allFieldsFilled &&
      isPincodeValid &&
      isMobileNoValid &&
      isValidLatitude &&
      isValidLongitude &&
      isOutletNameValid &&
      isOutletAddressValid &&
      isOutletCityValid &&
      otpValid
    );
  };
  const isPage2Complete = () => {
    const creditFields = {
      creditLimit: formData.creditLimit,
    };
    if (!canEditForm){
      return true
    }
    const page2Fields = {
      paymentMode: formData.paymentMode,
      // outletDiscount: formData.outletDiscount,
      
      // outletAccountNumber: formData.outletAccountNumber,
      // outletIfscCode: formData.outletIfscCode,
      // outletBank: formData.outletBank,
      // outletCashDiscount: formData.outletCashDiscount,
      tcsEligibility: formData.tcsEligibility,
    };
    const allFieldsFilled = Object.values(page2Fields).every(
      (value) => value !== ""
    );
    const allCreditFilled = Object.values(creditFields).every(
      (value) => value !== ""
    )
    let creditRequired;
    if (isAnyCreditFieldFilled()){
      creditRequired = allCreditFilled
    } else{
      creditRequired = true
    }
    return (
      (creditRequired) &&
      (!formData.creditLimit.length || formData.creditLimit.length >= 1) &&
      allFieldsFilled &&
      (!formData.outletDiscount.length ||
        formData.outletDiscount.length >= 1) &&
      (!formData.outletBank.length || formData.outletBank.length >= 5) &&
      (!formData.outletIfscCode.length ||
        formData.outletIfscCode.length === 11) &&
      (!formData.outletAccountNumber.length ||
        formData.outletAccountNumber.length >= 6) &&
      (!formData.outletCashDiscount.length ||
        formData.outletCashDiscount.length >= 1) &&
      (!formData.creditDays.length || formData.creditDays.length >= 1)
    );
  };
  const isPage3Complete = () => {
    if (!canEditForm){
      return true
    }
    const page3Fields = {
      // outletGstin: formData.outletGstin,
      // outletPan: formData.outletPan,
    };
    const allFieldsFilled = Object.values(page3Fields).every(
      (value) => value !== ""
    );
    const isOutletGstinValid =
      !formData.outletGstin.length || formData.outletGstin.length === 15;
    const isOutletPanValid =
      !formData.outletPan.length || formData.outletPan.length === 10;

    // Check if any Ship To field is filled
    const anyShipToFilled = isAnyShipToFieldFilled();

    // If any Ship To field is filled, all must be filled and valid
    if (anyShipToFilled) {
      const shipToFields = {
        shipToGstin: formData.shipToGstin,
        shipToContactPersonName: formData.shipToContactPersonName,
        shipToDescription: formData.shipToDescription,
        shipToAddress: formData.shipToAddress,
        shipToCity: formData.shipToCity,
        shipToContactNo: formData.shipToContactNo,
        shipToPincode: formData.shipToPincode,
        shipToState: formData.shipToState,
      };
      const allShipToFilled = Object.values(shipToFields).every(
        (value) => value !== ""
      );
      return (
        allFieldsFilled &&
        isOutletGstinValid &&
        isOutletPanValid &&
        allShipToFilled &&
        formData.shipToGstin.length === 15 &&
        formData.shipToContactPersonName.length >= 2 &&
        formData.shipToDescription.length >= 5 &&
        formData.shipToAddress.length >= 5 &&
        formData.shipToCity.length >= 3 &&
        MOBILE_NO_REGEX.test(formData.shipToContactNo) &&
        PINCODE_REGEX.test(formData.shipToPincode) &&
        formData.shipToState.length >= 2
      );
    }

    // If no Ship To field is filled, only outletGstin and outletPan are required
    return allFieldsFilled && isOutletGstinValid && isOutletPanValid;
  };
  const isPage4Complete = () => {
    if (!canEditForm){
      return true
    }
    const page4Fields = {
      outletStatus: formData.outletStatus,
      // outletType: formData.outletType,
      // subChannel: formData.subChannel,
      // loyaltyBalance: formData.loyaltyBalance,
      // walletBalance: formData.walletBalance,
      // outletCategory: formData.outletCategory,
      ...(!isPriceGroupRequired.current && {
        outletCategory: formData.outletCategory,
      }),
      ...(isPriceGroupRequired.current && {
        outletPriceGroup: formData.outletPriceGroup,
      }),
    };
    const allFieldsFilled = Object.values(page4Fields).every(
      (value) => value !== ""
    );
    return (
      allFieldsFilled &&
      (!formData.loyaltyBalance.length ||
        formData.loyaltyBalance.length >= 1) &&
      (!formData.walletBalance.length || formData.walletBalance.length >= 1)
    );
  };

  const handleSave = async () => {
    const formSaveModalProps = getGenericModalProps(
      "positive",
      "Are you sure you want to send this outlet for approval",
      "Confirm",
      "Cancel",
      async () => {
        if (buttonLoading.current) return;
        buttonLoading.current = true
        setButtonLoadingIcon(true)
        try {
          const data = await createOutlet(formData, defaultCreditLimit.current, defaultCreditDays.current);
          onSaveOutletForm?.(data, formData.outletRoute);
          setGenericModalProps(initialGenericModalProps);
          if (onClose) onClose();
        } catch (error) {
          console.error("Error creating outlet:", error);
          setGenericModalProps(
            getGenericModalProps(
              "error",
              "Failed to send outlet for approval. Please try again.",
              "OK",
              "",
              () => {
                setGenericModalProps(initialGenericModalProps);
              }
            )
          );
        } finally {
          buttonLoading.current = false
          setButtonLoadingIcon(false)
        }
      },
      () => {
        setGenericModalProps(initialGenericModalProps);
      }
    );

    const formUpdateModalProps = getGenericModalProps(
      "positive",
      "Are you sure you want to update this outlet? Existing outlet will be mapped to the new Distributor/Salesrep.",
      "Confirm",
      "Cancel",
      async () => {
        if (buttonLoading.current) return;
        buttonLoading.current = true
        setButtonLoadingIcon(true)
        try{
          const data = await updateOutlet(formData, duplicateOuletsData);
          setGenericModalProps(getGenericModalProps(
            "success",
            "Outlet updated successfully!",
            "Ok",
            "",
            () => {
              setGenericModalProps(initialGenericModalProps);
              if (onClose) onClose();
            }
          ))
        }catch(error){
          setGenericModalProps(getGenericModalProps(
            "error",
            "Failed to update Outlet Details. Please try again.",
            "Ok",
            "",
            () => {
              setGenericModalProps(initialGenericModalProps);
            }
          )
        )
        }finally{
          buttonLoading.current = false
          setButtonLoadingIcon(false)
        }
      },
      () => {
        setGenericModalProps(initialGenericModalProps);
      }
    )

    if (canEditForm){
      setGenericModalProps(formSaveModalProps);
    }else{
      setGenericModalProps(formUpdateModalProps);
    }
  };

  const handleSendOtp = async () => {
    const currentDateString = dayjs().format("YYYY-MM-DD");
    setVerifyLoader(true)
    const requestBody = getSendOtpRequestBody(
      formData.mobileNo,
      currentDateString,
      designation
    );
    // setTimeleft(MAX_TIME);
    try {
      const response = await sendOtpOutletCreation(requestBody);
      // const response = {status : 200}
      if (response.status === 200) {
        setResendOtpState(false);
        setShowOtpPopup(true);
      }
    } catch (error: any) {
      const status = error?.response?.status;
      setOtpStatus(otpState.INVALID);
      if (status === 400){
        setErrorMessage(`OTP verification was not completed. You can request a new OTP after 1 minute.`);
      } else{
        setErrorMessage("Please Try again later");
      }
    } finally {
      setVerifyLoader(false);
    }
  };

  function canSendOtp(): boolean {
    return (
      !!formData.mobileNo && // ensures it's not empty, null, or undefined
      !!formData.latitude &&
      !!formData.longitude &&
      !!formData.salesRepId &&
      !!formData.outletRoute &&
      isFieldValid("mobileNo") &&
      isFieldValid("latitude") &&
      isFieldValid("longitude") &&
      isFieldValid("salesRepId")
    );
  }

  const handleNext = () => {
    if (currentPage < 4) setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };



  const channelOptions = [...channelValues];
  const outletClassOptions = [...outletClassValues];
  const paymentModeOptions = [...paymentModeValues];
  const stateOptions = Object.keys(stateCityMap);

  const salesRepOptions = [...salesRepValues.map((rep) => rep.id)];

  // Define field length limits
  const fieldLengths: Record<keyof FormDataType, number> = {
    outletName: 200,
    city: 100,
    mobileNo: 10,
    pincode: 6,
    address: 250,
    salesRepId: 100,
    channel: 200,
    email: 100,
    managerName: 100,
    latitude: 10,
    keyAccount: 5,
    longitude: 10,
    outletClass: 50,
    state: 100,
    tcsEligibility: 5,
    // Add appropriate lengths for all other fields
    paymentMode: 6, // verify
    outletDiscount: 2,
    outletAccountNumber: 15,
    outletBank: 50,
    outletIfscCode: 11,
    creditLimit: 8,
    creditAvailable: 8,
    creditDays: 4,
    outletCashDiscount: 4,

    outletGstin: 15,
    outletPan: 10,
    shipToGstin: 15,
    shipToContactPersonName: 50,
    shipToDescription: 200,
    shipToAddress: 200,
    shipToCity: 50,
    shipToContactNo: 10,
    shipToPincode: 6,
    shipToState: 100,

    outletStatus: 100,
    outletType: 100,
    subChannel: 100,
    loyaltyBalance: 6,
    walletBalance: 6,
    outletPriceGroup: 10,
    outletCategory: 100,
    outletRoute: 100,
    supplierName: 150,
    salesRepName: 150,
  };
  // Define a type for your form data
  type FormDataType = {
    outletName: string;
    city: string;
    mobileNo: string;
    pincode: string;
    address: string;
    salesRepId: string;
    channel: string;
    email: string;
    managerName: string;
    latitude: string;
    keyAccount: string;
    longitude: string;
    outletClass: string;
    state: string;
    // Add all other form fields here
    // Page 2 fields
    paymentMode: string;
    outletDiscount: string;
    outletAccountNumber: string;
    outletBank: string;
    outletIfscCode: string;
    creditLimit: string;
    creditDays: string;
    creditAvailable: string;
    outletCashDiscount: string;
    tcsEligibility: string;
    // page 3 fields
    outletGstin: string;
    outletPan: string;
    shipToGstin: string;
    shipToContactPersonName: string;
    shipToDescription: string;
    shipToAddress: string;
    shipToCity: string;
    shipToContactNo: string;
    shipToPincode: string;
    shipToState: string;
    //page 4
    outletStatus: string;
    outletType: string;
    subChannel: string;
    loyaltyBalance: string;
    walletBalance: string;
    outletPriceGroup: string;
    outletCategory: string;
    outletRoute: string;
    supplierName: string;
    salesRepName: string;
  };

  const isAnyShipToFieldFilled = () => {
    const shipToFields = {
      shipToGstin: formData.shipToGstin,
      shipToContactPersonName: formData.shipToContactPersonName,
      shipToDescription: formData.shipToDescription,
      shipToAddress: formData.shipToAddress,
      shipToCity: formData.shipToCity,
      shipToContactNo: formData.shipToContactNo,
      shipToPincode: formData.shipToPincode,
      shipToState: formData.shipToState,
    };
    return Object.values(shipToFields).some((value) => value !== "");
  };

  const isAnyCreditFieldFilled = () => {
    const creditFields = {
      creditLimit: formData.creditLimit,
    };
    return Object.values(creditFields).some((value) => value !== "");

  }

  const validationMessages: Record<keyof FormDataType, string> = {
    outletName: "Outlet Name must be at least 2 characters",
    city: "City must be at least 3 characters",
    mobileNo: "Contact No. must be exactly 10 digits",
    pincode: "Pincode must be exactly 6 digits",
    state: "State is required",
    address: "Address must be at least 5 characters",
    salesRepId: "Sales Representative is required",
    channel: "Channel is required",
    email: "Enter a valid email address",
    managerName: "Manager Name is required",
    latitude: "Enter a valid latitude (-90 to 90)",
    keyAccount: "Key Account selection is required",
    longitude: "Enter a valid longitude (-180 to 180)",
    outletClass: "Outlet Class is required",
    paymentMode: "Payment Mode is required",
    outletDiscount: "Discount must be a valid number",
    outletAccountNumber: "Account Number must be at least 6 characters",
    outletBank: "Bank Name must be at least 5 characters",
    outletIfscCode: "IFSC Code must be exactly 11 characters",
    tcsEligibility: "Tcs Eligibility selection is required",
    creditLimit: "Credit Limit must be a valid number",
    creditDays: "Credit Days must be a valid number",
    creditAvailable: "Credit Available must be a valid number",
    outletCashDiscount: "Cash Discount must be a valid number",
    outletGstin: "GSTIN must be exactly 15 characters",
    outletPan: "PAN must be exactly 10 characters",
    shipToGstin: "Ship To GSTIN must be exactly 15 characters",
    shipToContactPersonName:
      "Contact Person Name must be at least 2 characters",
    shipToDescription: "Description must be at least 5 characters",
    shipToAddress: "Ship To Address must be at least 5 characters",
    shipToCity: "Ship To City must be at least 3 characters",
    shipToContactNo: "Ship To Contact No. must be exactly 10 digits",
    shipToPincode: "Ship To Pincode must be exactly 6 digits",
    shipToState: "Ship To State is required",
    outletStatus: "Outlet Status is required",
    outletType: "Outlet Type is required",
    subChannel: "Sub Channel is required",
    loyaltyBalance: "Loyalty Balance must be a valid number",
    walletBalance: "Wallet Balance must be a valid number",
    outletPriceGroup: "Price Group is required",
    outletCategory: "Category is required",
    outletRoute: "Route is required",
    supplierName: "Supplier Name is required",
    salesRepName: "Salesrep name is required",
  };

  const isFieldValid = (fieldName: keyof FormDataType): boolean => {
    const value = formData[fieldName];
    const anyShipToFilled = isAnyShipToFieldFilled();
    switch (fieldName) {
      // Page 1 Fields
      case "outletName":
        return value.length >= 2;
      case "city":
        return value.length >= 3;
      case "state":
        return value.length >= 2;
      case "mobileNo":
        return MOBILE_NO_REGEX.test(value);
      case "pincode":
        return PINCODE_REGEX.test(value);
      case "address":
        return value.length >= 5;
      case "salesRepId":
        return value !== "";
      case "channel":
        return value !== "";
      case "email":
        return !value || (value.length >= 11 && EMAIL_REGEX.test(value));
      case "latitude":
        return LATITUDE_REGEX.test(value);
      case "longitude":
        return LONGITUDE_REGEX.test(value);

      // Page 2 Fields
      case "paymentMode":
        return true;
      case "creditLimit":
        return !value || value.length >= 1;
      case "creditAvailable":
        return !value || value.length >= 1; 
      case "outletDiscount":
        return !value || value.length >= 1;
      case "outletBank":
        return !value || value.length >= 5;
      case "outletIfscCode":
        return !value || value.length === 11;
      case "outletAccountNumber":
        return !value || value.length >= 6;
      case "outletCashDiscount":
        return !value || value.length >= 1;
      case "creditDays":
        return !value || value.length >= 1;
      case "tcsEligibility":
        return value === "yes" || value === "no";

      // Page 3 Fields
      case "outletGstin":
        return !value || value.length === 15;
      case "outletPan":
        return !value || value.length === 10;
      case "shipToGstin":
        return !anyShipToFilled || value.length === 15;
      case "shipToContactPersonName":
        return !anyShipToFilled || value.length >= 2;
      case "shipToDescription":
        return !anyShipToFilled || value.length >= 5;
      case "shipToAddress":
        return !anyShipToFilled || value.length >= 5;
      case "shipToCity":
        return !anyShipToFilled || value.length >= 3;
      case "shipToContactNo":
        return !anyShipToFilled || MOBILE_NO_REGEX.test(value);
      case "shipToPincode":
        return !anyShipToFilled || PINCODE_REGEX.test(value);
      case "shipToState":
        return !anyShipToFilled || value.length >= 2;

      // Page 4 Fields
      case "outletStatus":
        return value === "active" || value === "inactive";
      case "outletPriceGroup":
        return !isPriceGroupRequired.current
          ? true
          : value !== "" && value !== outletPriceGroupOptions[0]; //for cavin kare remove this validation
      case "outletCategory":
        return !isPriceGroupRequired.current
          ? value !== "" && value !== categoryOptions[0]
          : true; // for cavin kare remove this validation
      case "outletRoute":
        return value !== "" && value !== outletRouteOptions[0];
      case "loyaltyBalance":
        return !value || value.length >= 1;
      case "walletBalance":
        return !value || value.length >= 1;
      case "outletType":
        return true; // Optional field; adjust if validation is added
      case "subChannel":
        return true; // Optional field; adjust if validation is added

      // Fields not explicitly validated in isPageXComplete
      case "managerName":
        return true; // Optional in your form; adjust if needed
      case "outletClass":
        return true; // Optional in your form; adjust if needed

      default:
        return !!value; // Default case for unhandled fields
    }
  };

  const [focusedField, setFocusedField] = useState<keyof FormDataType | null>(
    null
  );

  const outletTypeOptions = [...outletTypeValues];
  const subChannelOptions = [...subChannelValues];
  const outletPriceGroupOptions = [...priceListValues];
  const categoryOptions = [...categoryValues];
  const outletRouteOptions = [...routeValues];
  const cityOptions = [...cityValues];
  const shipToCityOptions = [...shipToCityValues];

  const styles = {
    formContainer: {
      backgroundColor: "#fff",
      border: "1px solid #e2e8f0",
      borderRadius: "8px",
      width: "1000px",
      height: "625px",
      margin: "0 auto",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    formTitle: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#464646",
      marginBottom: "20px",
    },
    formContent: {
      marginTop: 20,
      padding: "10px 40px",
      display: "flex",
      height: "350px",
      backgroundColor: "#FFF",
      justifyContent: "space-between",
    },
    formColumn: {
      width: "48%",
    },
    formGroup: {
      marginBottom: "15px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    formLabel: {
      fontSize: "14px",
      font: "Poppins', sans-serif !important",
      color: "#7C7C7C",
      marginRight: "10px",
      width: "150px",
    },
    required: {
      color: "#e53e3e",
    },
    formInput: {
      width: "300px",
      padding: "8px 12px",
      border: "1px solid #e2e8f0",
      borderColor: "#e2e8f0",
      borderRadius: "4px",
      fontSize: "14px",
      color: "#2d3748",
      backgroundColor: "#fff",
      transition: "border-color 0.2s ease-in-out",
    },
    formSelect: {
      width: "300px",
      padding: "8px 12px",
      border: "1px solid #e2e8f0",
      borderRadius: "4px",
      fontSize: "14px",
      color: "#2d3748",
      backgroundColor: "#fff",
      background: `url('data:image/svg+xml;utf8,<svg fill="none" stroke="%234A5568" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><polyline points="6 9 12 15 18 9"></polyline></svg>') no-repeat right 10px center`,
      backgroundSize: "16px",
      appearance: "none" as const,
      transition: "border-color 0.2s ease-in-out",
    },
    formButtons: {
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      marginTop: "20px",
      padding: "0px 35px 23px",
    },
    resetBtn: {
      padding: "10px 18px",
      borderRadius: "4px",
      fontSize: "14px",
      cursor: "pointer",
      backgroundColor: "#edf2f7",
      color: "#4a5568",
      border: "1px solid #e2e8f0",
      transition: "background-color 0.2s ease-in-out",
    },
    resetBtnHover: {
      backgroundColor: "#e2e8f0",
    },
    saveBtn: {
      padding: "10px 18px",
      borderRadius: "4px",
      fontSize: "14px",
      cursor: "pointer",
      backgroundColor: "#38b2ac",
      color: "#fff",
      border: "none",
      transition: "background-color 0.2s ease-in-out",
    },
    saveBtnHover: {
      backgroundColor: "#319795",
    },
    closeButton: {
      background: "none",
      border: "none",
      fontSize: "18px",
      fontWeight: 500,
      cursor: "pointer",
      color: "#252525",
    },
    progressCardContainer: {
      backgroundColor: "#fff",
      display: "flex",
      justifyContent: "center",
      padding: "15px 0px 10px 0px ",
      margin: "0 auto",
    },
    radioLabel: {
      marginRight: "0",
    },
    radioContainer: {
      display: "flex",
      alignItems: "center",
    },
    characterCountContainer: {
      height: "20px", // Fixed height to prevent expansion
      lineHeight: "20px", // Vertically center text
      marginBottom: "10px",
      textAlign: "right",
    },
  };

  const handleFocus = (fieldName: keyof FormDataType) => {
    setFocusedField(fieldName);
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  const VARCHAR_REGEX_PATTERN = new RegExp("^(?=.*\\S).+$");
  const PARTIAL_NUMERIC_REGEX = /^-?\d*\.?\d*$/;
  const handleLatLongChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (value === "" || PARTIAL_NUMERIC_REGEX.test(value)) {
      setOtpStatus(otpState.INVALID);
      const sanitized = value.replace(/\s+/g, ""); // remove all spaces
      setFormData((prev) => ({ ...prev, [name]: sanitized }));
    }
  };

  const handleVarcharData = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (VARCHAR_REGEX_PATTERN.test(value) || value === "") {
      setFormData((prev) => ({ ...prev, [name]: value.trimStart() }));
    }
  }
  
  const handleSixDigitData = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // Allow only numbers and restrict input length to 6 digits
    if (/^\d{0,6}$/.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleTenDigitData = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "mobileNo") {
      setOtpStatus(otpState.INVALID);
    }
    // Allow only numbers and restrict input length to 10 digits
    if (/^\d{0,10}$/.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleDigitInput =
    (maxLength: number) => (e: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;

      // Allow only an empty string or up to 'maxLength' digits
      const digitRegex = new RegExp(`^\\d{0,${maxLength}}$`);

      if (digitRegex.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    };

  const setSelectedSalesrepName = (id: string) => {
    const selected = salesRepValues.find((rep) => rep.id === id);
    if (selected) {
      setFormData((prev) => ({
        ...prev,
        salesRepName: selected.name,
      }));
    }
  };

  const fieldsToRemove = new Set([
    ...(isPriceGroupRequired.current ? [] : ["outletPriceGroup"]),
    ...(isPriceGroupRequired.current ? ["outletCategory"] : []),
  ]);
  const fieldConfigData = keysToAddConfig(fieldsToRemove);
  const fieldConfig = Object.fromEntries(fieldConfigData);

  const renderPageContent = () => {
    switch (currentPage) {
      case 1:
        return (
          <div style={styles.formContent}>
            <div style={styles.formColumn}>
              {fieldConfig.managerName && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Distributor</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.managerName}
                    onFocus={() => handleFocus("managerName")}
                    onContextMenu={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()} // Prevents cutting
                    onPaste={(e) => e.preventDefault()} // Prevents pasting
                    onBlur={handleBlur}
                    type="text"
                    name="managerName"
                    autoComplete="off"
                    value={formData.managerName}
                    // onChange={handleVarcharData}
                    style={{...styles.formInput,  ...diabledFieldColor()}}
                    disabled
                  />
                </div>
              )}
              {fieldConfig.outletName && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet Name<span style={styles.required}>*</span>
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.outletName}
                    onFocus={() => handleFocus("outletName")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="outletName"
                    value={formData.outletName}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("outletName"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.email && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Email ID </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.email}
                    onFocus={() => handleFocus("email")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="email"
                    value={formData.email}
                    autoComplete="off"
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("email"),
                      ...diabledFieldColor()
                    }}
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.address && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet Address
                    <span style={styles.required}>*</span>
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.address}
                    onFocus={() => handleFocus("address")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("address"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.state && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet State{<span style={styles.required}>*</span>}
                  </label>
                  <FormControl
                    size="small"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    className="custom_form_control"
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="state-autocomplete"
                      options={stateOptions}
                      value={formData.state || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "state",
                          newValue ?? "",
                          stateOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}
              {fieldConfig.city && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet City{<span style={styles.required}>*</span>}
                  </label>
                  <FormControl
                    size="small"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    className="custom_form_control"
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="state-autocomplete"
                      options={cityOptions}
                      value={formData.city || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "city",
                          newValue ?? "",
                          cityOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}
              {fieldConfig.pincode && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet Pincode
                    <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    spellCheck="false"
                    maxLength={fieldLengths.pincode}
                    onFocus={() => handleFocus("pincode")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    onChange={handleSixDigitData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("pincode"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
            </div>

            <div style={styles.formColumn}>
              {fieldConfig.latitude && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet Lat<span style={styles.required}>*</span>
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.latitude}
                    onFocus={() => handleFocus("latitude")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="latitude"
                    value={formData.latitude}
                    autoComplete="off"
                    onChange={handleLatLongChange}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("latitude"),
                      ...diabledFieldColor()
                    }}
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.longitude && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet Long<span style={styles.required}>*</span>
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.longitude}
                    onFocus={() => handleFocus("longitude")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="longitude"
                    value={formData.longitude}
                    autoComplete="off"
                    onChange={handleLatLongChange}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("longitude"),
                      ...diabledFieldColor()
                    }}
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.salesRepId && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    MGR/SalesRep<span style={styles.required}>*</span>
                  </label>
                  <FormControl
                    size="small"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    className="custom_form_control"
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="class-autocomplete"
                      options={salesRepOptions}
                      value={formData.salesRepId || null}
                      onChange={(event, newValue) => {
                        handleAutocompleteSelect(
                          "salesRepId",
                          newValue ?? "",
                          salesRepOptions
                        );
                        setSelectedSalesrepName(newValue ?? "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}
              {fieldConfig.outletRoute && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Route<span style={styles.required}>*</span>
                  </label>

                  <FormControl
                    size="small"
                    className="custom_form_control"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="route-autocomplete"
                      options={outletRouteOptions}
                      value={formData.outletRoute || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "outletRoute",
                          newValue ?? "",
                          outletRouteOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}
              {fieldConfig.mobileNo && (
                <div style={{ ...styles.formGroup, position: "relative" }}>
                  <label style={styles.formLabel}>
                    Outlet Contact No.
                    <span style={styles.required}>*</span>
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.mobileNo}
                    onFocus={() => handleFocus("mobileNo")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="mobileNo"
                    value={formData.mobileNo}
                    onChange={handleTenDigitData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("mobileNo"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                  <div
                    style={{
                      position: "absolute",
                      right: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {otpStatus === otpState.VALID ? (
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#1C7EA0",
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        {"Verified"}
                        <CheckCircleOutlineIcon
                          sx={{ color: "rgb(34, 182, 85)", height: "20px" }}
                        />
                      </span>
                    ) : (
                      
                      <span>
                        {verifyLoader ? (
                          <div style={{display: 'flex', alignItems: "center", color: "#1C7EA0", cursor: "not-allowed"}}>
                            <CircularProgress size={15} color="inherit"  />
                          </div>
                        ) : (
                        <span 
                          style={{
                            cursor: canSendOtp() ? "pointer" : "not-allowed",
                            fontSize: "13px",
                            color: canSendOtp() ? "#1C7EA0" : "#aaa",
                            pointerEvents: canSendOtp() ? "auto" : "none",
                            fontWeight: 500,
                          }}
                          onClick={async () => {
                            if (canSendOtp()) {
                              await handleSendOtp();
                            }
                          }}>{"Verify"}</span>
                        )}
                      </span>
                    )}
                  </div>
                </div>
              )}
              {fieldConfig.outletClass && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Class </label>
                  <FormControl
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    size="small"
                    className="custom_form_control"
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="class-autocomplete"
                      options={outletClassOptions}
                      value={formData.outletClass || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "outletClass",
                          newValue ?? "",
                          outletClassOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}
              
              {fieldConfig.channel && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet Channel<span style={styles.required}>*</span>
                  </label>
                  <FormControl
                    size="small"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    className="custom_form_control"
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="channel-autocomplete"
                      options={channelOptions}
                      value={formData.channel || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "channel",
                          newValue ?? "",
                          channelOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}
            </div>
          </div>
        );

      case 2:
        return (
          <div style={styles.formContent}>
            <div style={styles.formColumn}>
              {fieldConfig.paymentMode && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Payment Mode<span style={styles.required}>*</span></label>
                  <FormControl
                    size="small"
                    className="custom_form_control"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="payment-autocomplete"
                      options={paymentModeOptions}
                      value={formData.paymentMode || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "paymentMode",
                          newValue ?? "",
                          paymentModeOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}
              {fieldConfig.outletBank && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Bank</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.outletBank}
                    onFocus={() => handleFocus("outletBank")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="outletBank"
                    value={formData.outletBank}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("outletBank"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.outletAccountNumber && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Account Number</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.outletAccountNumber}
                    onFocus={() => handleFocus("outletAccountNumber")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="outletAccountNumber"
                    value={formData.outletAccountNumber}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("outletAccountNumber"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.outletIfscCode && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet IFSC Code</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.outletIfscCode}
                    onFocus={() => handleFocus("outletIfscCode")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="outletIfscCode"
                    value={formData.outletIfscCode}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("outletIfscCode"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.tcsEligibility && (
                <div style={{ ...styles.formGroup, justifyContent: "left" }}>
                  <label style={styles.formLabel}>
                    TCS Eligibility<span style={styles.required}>*</span>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                    }}
                  >
                    <RadioGroup
                      row
                      onCopy={(e) => e.preventDefault()} // Prevents copying
                      onContextMenu={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()} // Prevents cutting
                      onPaste={(e) => e.preventDefault()} // Prevents pasting
                      onBlur={handleBlur}
                      name="tcsEligibility"
                      value={formData.tcsEligibility}
                      onChange={handleChange}
                      sx={{ paddingLeft: "0.5rem" }}
                    >
                      <FormControlLabel
                        value="Y"
                        disabled={!canEditForm}
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: "0.9rem",
                              },
                            }}
                          />
                        }
                        label="Yes"
                        sx={{
                          color: "#606060",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                          },
                          mr: 0,
                          letterSpacing: 0,
                          marginLeft: "-9px",
                          marginRight: "10p",
                        }}
                      />
                      <FormControlLabel
                        value="N"
                        disabled={!canEditForm}
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: "0.9rem",
                              },
                            }}
                          />
                        }
                        label="No"
                        sx={{
                          color: "#606060",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                          },
                          mr: 0,
                          letterSpacing: 0,
                        }}
                      />
                    </RadioGroup>
                  </div>
                </div>
              )}
            </div>

            <div style={styles.formColumn}>
              {fieldConfig.creditLimit && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Credit Limit
                    {isAnyCreditFieldFilled() && <span style={styles.required}>*</span>}
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.creditLimit}
                    onFocus={() => handleFocus("creditLimit")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="creditLimit"
                    autoComplete="off"
                    value={formData.creditLimit}
                    onChange={handleDigitInput(8)}
                    style={{...styles.formInput, ...diabledFieldColor()}}
                    disabled={!canEditForm || !outletIsCredit.current}
                  />
                </div>
              )}
              {fieldConfig.creditAvailable && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Credit Available
                    {isAnyCreditFieldFilled() && <span style={styles.required}>*</span>}
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.creditAvailable}
                    onFocus={() => handleFocus("creditAvailable")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="creditAvailable"
                    value={formData.creditAvailable}
                    onChange={handleDigitInput(8)}
                    style={{...styles.formInput, ...diabledFieldColor()}}
                    autoComplete="off"
                    disabled={!canEditForm || !outletIsCredit.current}
                  />
                </div>
              )}
              {fieldConfig.creditDays && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Credit Days
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.creditDays}
                    onFocus={() => handleFocus("creditDays")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="creditDays"
                    value={formData.creditDays}
                    onChange={handleDigitInput(4)}
                    
                    style={{...styles.formInput, ...diabledFieldColor()}}
                    autoComplete="off"
                    disabled={!canEditForm || !outletIsCredit.current}
                  />
                </div>
              )}
              
              {fieldConfig.outletDiscount && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Discount(%)</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.outletDiscount}
                    onFocus={() => handleFocus("outletDiscount")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="outletDiscount"
                    value={formData.outletDiscount}
                    onChange={handleDigitInput(2)}
                    style={{...styles.formInput, ...diabledFieldColor()}}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.outletCashDiscount && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Cash Discount</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.outletCashDiscount}
                    onFocus={() => handleFocus("outletCashDiscount")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="outletCashDiscount"
                    value={formData.outletCashDiscount}
                    onChange={handleDigitInput(4)}
                    style={{...styles.formInput, ...diabledFieldColor()}}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
            </div>
          </div>
        );
      case 3:
        const anyShipToFilled = isAnyShipToFieldFilled();
        return (
          <div style={styles.formContent}>
            <div style={styles.formColumn}>
              {fieldConfig.outletGstin && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet GSTIN</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.outletGstin}
                    onFocus={() => handleFocus("outletGstin")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="outletGstin"
                    autoComplete="off"
                    value={formData.outletGstin}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("outletGstin"),
                      ...diabledFieldColor()
                    }}
                    disabled={!canEditForm}
                  />
                </div>
              )}

              {fieldConfig.outletPan && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet PAN</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.outletPan}
                    onFocus={() => handleFocus("outletPan")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="outletPan"
                    autoComplete="off"
                    value={formData.outletPan}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("outletPan"),
                      ...diabledFieldColor()
                    }}
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.shipToContactPersonName && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Ship To Contact Person Name
                    {anyShipToFilled && <span style={styles.required}>*</span>}
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.shipToContactPersonName}
                    onFocus={() => handleFocus("shipToContactPersonName")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="shipToContactPersonName"
                    value={formData.shipToContactPersonName}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("shipToContactPersonName"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.shipToContactNo && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Ship To Contact No.
                    {anyShipToFilled && <span style={styles.required}>*</span>}
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.shipToContactNo}
                    onFocus={() => handleFocus("shipToContactNo")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="shipToContactNo"
                    value={formData.shipToContactNo}
                    onChange={handleTenDigitData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("shipToContactNo"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.shipToAddress && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Ship To Address
                    {anyShipToFilled && <span style={styles.required}>*</span>}
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.shipToAddress}
                    onFocus={() => handleFocus("shipToAddress")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="shipToAddress"
                    value={formData.shipToAddress}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("shipToAddress"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
            </div>
            <div style={styles.formColumn}>
              {fieldConfig.shipToState && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Ship To State
                    {anyShipToFilled && <span style={styles.required}>*</span>}
                  </label>
                  <FormControl
                    size="small"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    className="custom_form_control"
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="shipToState-autocomplete"
                      options={stateOptions}
                      value={formData.shipToState || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "shipToState",
                          newValue ?? "",
                          stateOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}

              {fieldConfig.shipToCity && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Ship To City
                    {anyShipToFilled && <span style={styles.required}>*</span>}
                  </label>
                  <FormControl
                    size="small"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    className="custom_form_control"
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="state-autocomplete"
                      options={shipToCityOptions}
                      value={formData.shipToCity || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "shipToCity",
                          newValue ?? "",
                          shipToCityOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}

              {fieldConfig.shipToPincode && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Ship To Pincode
                    {anyShipToFilled && <span style={styles.required}>*</span>}
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.shipToPincode}
                    onFocus={() => handleFocus("shipToPincode")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="shipToPincode"
                    value={formData.shipToPincode}
                    onChange={handleSixDigitData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("shipToPincode"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.shipToDescription && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Ship To Description
                    {anyShipToFilled && <span style={styles.required}>*</span>}
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.shipToDescription}
                    onFocus={() => handleFocus("shipToDescription")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="shipToDescription"
                    value={formData.shipToDescription}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("shipToDescription"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.shipToGstin && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Ship To GSTIN
                    {anyShipToFilled && <span style={styles.required}>*</span>}
                  </label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.shipToGstin}
                    onFocus={() => handleFocus("shipToGstin")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="shipToGstin"
                    value={formData.shipToGstin}
                    onChange={handleVarcharData}
                    style={{
                      ...styles.formInput,
                      ...invalidFieldColor("shipToGstin"),
                      ...diabledFieldColor()
                    }}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
            </div>
          </div>
        );
      case 4:
        return (
          <div style={styles.formContent}>
            <div style={styles.formColumn}>
              {fieldConfig.outletStatus && (
                <div style={{ ...styles.formGroup, justifyContent: "left" }}>
                  <label style={styles.formLabel}>
                    Outlet Status<span style={styles.required}>*</span>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                    }}
                  >
                    <RadioGroup
                      row
                      onCopy={(e) => e.preventDefault()} // Prevents copying
                      onContextMenu={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()} // Prevents cutting
                      onPaste={(e) => e.preventDefault()} // Prevents pasting
                      onBlur={handleBlur}
                      name="outletStatus"
                      value={formData.outletStatus}
                      onChange={handleChange}
                      sx={{ paddingLeft: "0.5rem" }}
                    >
                      <FormControlLabel
                        value="active"
                        disabled
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: "0.9rem",
                              },
                            }}
                          />
                        }
                        label="Active"
                        sx={{
                          color: "#606060",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                          },
                          mr: 0,
                          letterSpacing: 0,
                          marginLeft: "-9px",
                          marginRight: "10p",
                        }}
                      />
                      <FormControlLabel
                        value="inactive"
                        disabled={!canEditForm}
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: "0.9rem",
                              },
                            }}
                          />
                        }
                        label="Inactive"
                        sx={{
                          color: "#606060",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                          },
                          mr: 0,
                          letterSpacing: 0,
                        }}
                      />
                    </RadioGroup>
                  </div>
                  {formData.outletStatus === "inactive" && (
                    <Tooltip
                      title={"The outlet will be inactive till it is approved"}
                    >
                      <InfoIcon
                        color="info"
                        style={{
                          marginLeft: "8px",
                          height: "15px",
                          width: "15px",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  )}
                </div>
              )}

              {fieldConfig.outletType && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Outlet Type</label>
                  <FormControl
                    size="small"
                    className="custom_form_control"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="type-autocomplete"
                      options={outletTypeOptions}
                      value={formData.outletType || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "outletType",
                          newValue ?? "",
                          outletTypeOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}

              {fieldConfig.subChannel && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Sub Channel</label>

                  <FormControl
                    size="small"
                    className="custom_form_control"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="subChannel-autocomplete"
                      options={subChannelOptions}
                      value={formData.subChannel || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "subChannel",
                          newValue ?? "",
                          subChannelOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}

              {fieldConfig.outletCategory && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Category<span style={styles.required}>*</span></label>
                  <FormControl
                    size="small"
                    className="custom_form_control"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="category-autocomplete"
                      options={categoryOptions}
                      value={formData.outletCategory || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "outletCategory",
                          newValue ?? "",
                          categoryOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}
            </div>

            <div style={styles.formColumn}>
              {fieldConfig.outletPriceGroup && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Outlet Price Group
                    {isPriceGroupRequired.current && (
                      <span style={styles.required}>*</span>
                    )}
                  </label>
                  <FormControl
                    size="small"
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    className="custom_form_control"
                    sx={{ ...customSxOutletForm, width: "300px" }}
                  >
                    <Autocomplete
                      id="priceGroup-autocomplete"
                      options={outletPriceGroupOptions}
                      value={formData.outletPriceGroup || null}
                      onChange={(event, newValue) =>
                        handleAutocompleteSelect(
                          "outletPriceGroup",
                          newValue ?? "",
                          outletPriceGroupOptions
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Here"
                          size="small"
                        />
                      )}
                      fullWidth
                      disableClearable={false} // allow clearing selection
                      ListboxProps={{ style: { maxHeight: 150 } }}
                      sx={{ ...customSxOutletForm, ...autocompleteLableMarginFix }}
                      disabled={!canEditForm}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ color: "#464646", fontSize: "14px" }}
                        >
                          {option}
                        </li>
                      )}
                    />
                  </FormControl>
                </div>
              )}

              {fieldConfig.loyaltyBalance && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Loyalty Balance</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.loyaltyBalance}
                    onFocus={() => handleFocus("loyaltyBalance")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="loyaltyBalance"
                    value={formData.loyaltyBalance}
                    onChange={handleDigitInput(6)}
                    style={{...styles.formInput, ...diabledFieldColor()}}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}

              {fieldConfig.walletBalance && (
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Wallet Balance</label>
                  <input
                    spellCheck="false"
                    maxLength={fieldLengths.walletBalance}
                    onFocus={() => handleFocus("walletBalance")}
                    onContextMenu={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    type="text"
                    name="walletBalance"
                    value={formData.walletBalance}
                    onChange={handleDigitInput(6)}
                    style={{...styles.formInput, ...diabledFieldColor()}}
                    autoComplete="off"
                    disabled={!canEditForm}
                  />
                </div>
              )}
              {fieldConfig.keyAccount && (
                <div style={{ ...styles.formGroup, justifyContent: "left" }}>
                  <label style={styles.formLabel}>Key Account(Y/N)</label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                    }}
                  >
                    <RadioGroup
                      row
                      name="keyAccount"
                      onCopy={(e) => e.preventDefault()} // Prevents copying
                      onContextMenu={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()} // Prevents cutting
                      onPaste={(e) => e.preventDefault()} // Prevents pasting
                      onBlur={handleBlur}
                      value={formData.keyAccount}
                      onChange={handleChange}
                      sx={{ paddingLeft: "0.5rem" }}
                    >
                      <FormControlLabel
                        value={true}
                        disabled={!canEditForm}
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: "0.9rem",
                              },
                            }}
                          />
                        }
                        label="Yes"
                        sx={{
                          color: "#606060",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "16px",
                          },
                          mr: 0,
                          letterSpacing: 0,
                          marginLeft: "-9px",
                          marginRight: "10p",
                        }}
                      />
                      <FormControlLabel
                        value={false}
                        disabled={!canEditForm}
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: "0.9rem",
                              },
                            }}
                          />
                        }
                        label="No"
                        sx={{
                          color: "#606060",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "16px",
                          },
                          mr: 0,
                          letterSpacing: 0,
                        }}
                      />
                    </RadioGroup>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <CustomGenericModal
        type={genericModalProps?.type}
        message={genericModalProps?.message}
        leftButtonText={genericModalProps?.leftButtonText}
        rightButtonText={genericModalProps?.rightButtonText}
        modalOpen={genericModalProps?.open}
        onLeftButtonClick={genericModalProps?.onLeftButtonClick}
        onRightButtonClick={genericModalProps?.onRightButtonClick}
        loading={buttonLoadingIcon}
      />
      <ValidateOtpPopupCounterSales
        showPopup={showOtpPopup}
        onClose={() => handleOtpPopupClose()}
        formData={formData}
        setOtpStatus={setOtpStatus}
        setDuplicateOutletsData={setDuplicateOutletsData}
        setErrorMessage={setErrorMessage}
        resendOtpState={resendOtpState}
        setResendOtpState={setResendOtpState}
        resetForm={resetForm}
        outletLocationTransformerName={outletLocationTransformerName.current}
        // Timeleft={Timeleft}
        // setTimeleft={setTimeleft}
      />
      <div style={styles.formContainer}>
        <div
          style={{
            backgroundColor: "#F0FBFF",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            padding: "20px 40px",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px"
          }}
        >
          <h2 style={{ ...styles.formTitle, flexGrow: 1, margin: 0 }}>
            Add New Outlet
            {/* (Page {currentPage} of 4) */}
          </h2>
          {/* {((currentPage === 1 && !isPage1Complete()) ||
            (currentPage === 2 && !isPage2Complete()) ||
            (currentPage === 3 && !isPage3Complete()) ||
            (currentPage === 4 && !isPage4Complete())) && (
            <p
              className="invalid_qty_text"
              style={{
                fontSize: "12px",
                color: "red",
                top: "135px",
                right: "100px",
                left: "4%",
              }}
            >
              <DisclaimerIcon />
              Fields marked with * are mandatory.
            </p>
          )} */}
          <button
            style={styles.closeButton}
            onClick={handleCloseClick}
            aria-label="Close form"
          >
            ✕
          </button>
        </div>
        {!loading ? (
          <>
            <div style={styles.progressCardContainer}>
              <OutletFormProgressCard
                setCurrentPage={setCurrentPage}
                isPage1Complete={isPage1Complete}
                isPage2Complete={isPage2Complete}
                isPage3Complete={isPage3Complete}
                isPage4Complete={isPage4Complete}
                currentPage={currentPage}
                trackingStagesList={counterSalesOutletFormTrackingStages.value}
                stages={stages}
              />
            </div>
            {canEditForm ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                {focusedField
                  ? !isFieldValid(focusedField) && (
                      <p
                        className="invalid_qty_text"
                        style={{
                          fontSize: "12px",
                          color: "red",
                          top: "145px",
                          right: "100px",
                          left: "4%",
                        }}
                      >
                        <DisclaimerIcon />
                        {validationMessages[focusedField]}
                      </p>
                    )
                  : ((currentPage === 1 && !isPage1Complete()) ||
                      (currentPage === 2 && !isPage2Complete()) ||
                      (currentPage === 3 && !isPage3Complete()) ||
                      (currentPage === 4 && !isPage4Complete())) && (
                      <p
                        className="invalid_qty_text"
                        style={{
                          fontSize: "12px",
                          color: "red",
                          top: "145px",
                          right: "100px",
                          left: "4%",
                        }}
                      >
                        <DisclaimerIcon />
                        {otpStatus === otpState.INVALID ? (
                          <span>
                            Please enter Salesrep ID, Route, Mobile No, Lat, and Long to proceed with OTP verification.
                          </span>
                        ) : (
                          <span>Fields marked with * are mandatory.</span>
                        )}
                      </p>
                    )}
              </div>
            ) : ((currentPage === 2 || currentPage === 3) &&
               <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <p
                  className="invalid_qty_text"
                  style={{
                    fontSize: "12px",
                    color: "#cc911f",
                    top: "145px",
                    right: "100px",
                    left: "4%",
                  }}
                >
                  {"*Outlet's account details are hidden for security reasons."}
                </p>
              </div>
            )}

            {renderPageContent()}

            <div style={styles.formButtons}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "flex-end",
                }}
              >
                {/* Left side: Previous button */}
                {currentPage > 1 && (
                  <button
                    style={{ ...styles.resetBtn, marginTop: "auto" }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        styles.resetBtnHover.backgroundColor)
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        styles.resetBtn.backgroundColor)
                    }
                    onClick={handlePrevious}
                  >
                    Previous
                  </button>
                )}
                {currentPage === 1 && <div></div>}{" "}
                {/* Placeholder for when Previous is not shown */}
                {/* Right side: Character count above Reset and Next */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "10px",
                      fontSize: "14px",
                      marginRight: "10px",
                    }}
                  >
                    <span
                      style={{
                        color: focusedField ? "#7C7C7C" : "#000000",
                        opacity: focusedField ? 1 : 0,
                      }}
                    >
                      {focusedField
                        ? `${formData[focusedField].length}/${fieldLengths[focusedField]}`
                        : "0/10"}
                    </span>
                  </div>

                  {/* Reset and Next buttons */}
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      style={{
                        ...styles.resetBtn,
                        opacity: isFormEmpty() ? 0.5 : 1,
                        cursor: isFormEmpty() ? "not-allowed" : "pointer",
                      }}
                      onMouseOver={(e) => {
                        if (!isFormEmpty()) {
                          e.currentTarget.style.backgroundColor =
                            styles.resetBtnHover.backgroundColor;
                        }
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor =
                          styles.resetBtn.backgroundColor;
                      }}
                      onClick={isFormEmpty() ? undefined : handleReset}
                      disabled={isFormEmpty()}
                    >
                      Reset
                    </button>
                    <button
                      style={{
                        ...styles.saveBtn,
                        opacity:
                          (currentPage === 1 && !isPage1Complete()) ||
                          (currentPage === 2 && !isPage2Complete()) ||
                          (currentPage === 3 && !isPage3Complete()) ||
                          (currentPage === 4 && !isPage4Complete())
                            ? 0.5
                            : 1,
                        cursor:
                          (currentPage === 1 && !isPage1Complete()) ||
                          (currentPage === 2 && !isPage2Complete()) ||
                          (currentPage === 3 && !isPage3Complete()) ||
                          (currentPage === 4 && !isPage4Complete())
                            ? "not-allowed"
                            : "pointer",
                      }}
                      onMouseOver={(e) => {
                        if (
                          !(
                            (currentPage === 1 && !isPage1Complete()) ||
                            (currentPage === 2 && !isPage2Complete()) ||
                            (currentPage === 3 && !isPage3Complete()) ||
                            (currentPage === 4 && !isPage4Complete())
                          )
                        ) {
                          e.currentTarget.style.backgroundColor =
                            styles.saveBtnHover.backgroundColor;
                        }
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor =
                          styles.saveBtn.backgroundColor;
                      }}
                      onClick={currentPage === 4 ? handleSave : handleNext}
                      disabled={
                        (currentPage === 1 && !isPage1Complete()) ||
                        (currentPage === 2 && !isPage2Complete()) ||
                        (currentPage === 3 && !isPage3Complete()) ||
                        (currentPage === 4 && !isPage4Complete())
                      }
                    >
                      {currentPage === 4 ? "Save" : "Next"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <Loader sx={{ position: "absolute", top: "42%" }} />
        )}
      </div>
    </>
  );
};
export default OutletForm;
